"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRecipientCreate = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _reactRedux = require("react-redux");

var _recipient = require("../store/recipient/recipient.selector");

var _gift = require("../store/gift/gift.actions");

var _recipient2 = require("../store/recipient/recipient.actions");

var useRecipientCreate = function useRecipientCreate(onCreate) {
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useState = (0, _react.useState)({}),
      _useState2 = (0, _slicedToArray2.default)(_useState, 1),
      emptyRecipient = _useState2[0];

  var recipient = (0, _reactRedux.useSelector)(_recipient.getRecipient) || emptyRecipient;
  var id = recipient.id;
  (0, _react.useEffect)(function () {
    if (id) {
      onCreate(recipient);
    }

    return function () {
      dispatch((0, _gift.giftCreateReset)());
      dispatch((0, _recipient2.giftCreateRecipientReset)());
    };
  }, [dispatch, id, onCreate, recipient]);
};

exports.useRecipientCreate = useRecipientCreate;